// extracted by mini-css-extract-plugin
module.exports = {"GuidesList":"GuidesList_GuidesList__3XHdq","GuideItem":"GuidesList_GuideItem__12Fom"};